import { useBuildingData } from 'store/building/hooks';
import { useIntl } from 'react-intl';
import { startCase } from 'lodash-es';

export const useCheckInOption = (id?: string | null): string | undefined => {
  const { formatMessage } = useIntl();
  const { visitTypes } = useBuildingData();
  const selectedVisitType = visitTypes?.find((visitType) => visitType.id.toString() === id);
  const selectedVisitTypeCode = selectedVisitType?.code.replace(/-/g, '_');

  return (
    selectedVisitTypeCode &&
    formatMessage({
      id: `labels.visitTypes.${selectedVisitTypeCode}`,
      defaultMessage: startCase(selectedVisitType?.name?.toLowerCase()),
    })
  );
};
